import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonV3Component } from '@gea/digital-ui-lib';
import { Divider } from 'primeng/divider';

@Component({
  selector: 'app-reset-workspace-dialog',
  standalone: true,
  imports: [ButtonV3Component, Divider],
  templateUrl: './reset-workspace-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetWorkspaceDialogComponent {
  constructor(private dialogRef: DynamicDialogRef) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
